getTypenameFromStoreObject